/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useDispatch } from 'react-redux';
import likeImage from '../../assets/like.svg';
import unlikeImage from '../../assets/unlike.svg';
import { setLikeVideo, setUnlikeVideo } from '../../features/video/videoSlice';

export default function LikeUnlike({ id, likes, unlikes }) {
    const dispatch = useDispatch();

    const likeIncrementHandler = (id) => {
        dispatch(setLikeVideo(id));
    };

    const unlikeIncrementHandler = (id) => {
        dispatch(setUnlikeVideo(id));
    };

    return (
        <div className="flex gap-10 w-48">
            <div className="flex gap-1">
                <div className="shrink-0">
                    <img
                        className="w-5 block"
                        onClick={() => likeIncrementHandler(id)}
                        src={likeImage}
                        alt="Like"
                    />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">{likes}</div>
            </div>
            <div className="flex gap-1">
                <div className="shrink-0">
                    <img
                        className="w-5 block"
                        onClick={() => unlikeIncrementHandler(id)}
                        src={unlikeImage}
                        alt="Unlike"
                    />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">{unlikes}</div>
            </div>
        </div>
    );
}
